import React from "react";
import { formatProductionLabel } from "../../utils/productionSource";

const SOURCE_CLASS = {
  Girabat: "bg-indigo-100 text-indigo-800 border-indigo-200",
  TeePlus: "bg-emerald-100 text-emerald-800 border-emerald-200",
  Printlet: "bg-fuchsia-100 text-fuchsia-800 border-fuchsia-200",
};

export default function ProductionSourceBadge({ source, className = "" }) {
  const label = formatProductionLabel(source);
  if (!label) return null;

  const color = SOURCE_CLASS[source] || "bg-slate-100 text-slate-800 border-slate-200";
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold border ${color} ${className}`}
      title="مصدر الإنتاج الحالي"
    >
      {label}
    </span>
  );
}
